export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
  }

  build() {
    let iconSlot = this.buildIconSlot()
    let titleSlot = this.buildTitleSlot()
    let textSlot = this.buildTextSlot()
    return `
      <wfs-alert
        classes="${this.classes.classes}"
        id="${this.ids.id}"
        ${this.content.isClosable ? 'isClosable' : ''}
        ${this.content.hasIcon ? 'hasIcon' : ''}
        ${this.content.hasTitle ? 'hasTitle' : ''}
      >
        ${iconSlot}
        ${titleSlot}
        ${textSlot}
      </wfs-alert>`
    }

  buildIconSlot() {
    if (! this.content.hasIcon) {
      return ''
    }
    return `<template v-slot:icon>
      <div
        id="${this.ids.iconContainerId}"
        class="wf-flex wf-items-center wf-justify-center ${this.classes.iconContainerClasses}"
      >
        <i id="${this.ids.iconId}" class="${this.content.class} ${this.content.icon}"></i>
      </div>
    </template>`
  }

  buildTitleSlot() {
    if (! this.content.hasTitle) {
      return ''
    }
    return  `<template v-slot:title>
      ${this.content.titleText}
    </template>`
  }

  buildTextSlot() {
    return `<template v-slot:text>
      ${this.content.text}
    </template>`
  }
}